// @core/api/endpoints/localization/get_translation_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TranslationStatsResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get translation stats
 * Returns translation coverage statistics per locale, including total keys, translated keys, and coverage percentage.
 */
export async function GetTranslationStats(
  params?: {
  },
  options?: RequestOptions
): Promise<TranslationStatsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/stats`;
  const requestOptions = options;
  return client.get<TranslationStatsResponse>(requestPath, { ...requestOptions, params });
}
